import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import { PingPong } from '../../icons';
import { EVENT_FAQ_CONST } from '../data/constants';
import { eventFaqDefinition, miscEventFaqDefinitions, category_labels } from '../data/eventFaqDefinition';

const EventActivitiesExpanded = ({ faqData = {}, hasOtherProhibitedActivity, prohibitedActivities, intl }) => {
  const { OTHER_PROHIBITED_ACTIVITY } = EVENT_FAQ_CONST;
  const label = <FormattedMessage
    id={category_labels.activities.id}
    defaultMessage={category_labels.activities.defaultMessage}
  />;
  return (
    <div className="EventFAQ">
      <div className="flex middle">
        <PingPong height={24} width={24} className="margin-sm-right" />
        <div className="h6 margin-md-left padding-xs-top padding-xs-bottom faq-section">{label}</div>
      </div>
      <div className='section-indent margin-lg-bottom'>
        <div className="faq-label heavier margin-md-bottom">
          {intl.formatMessage(miscEventFaqDefinitions.activities_not_permitted_header)}
        </div>
        {prohibitedActivities.map((activity, key) => (
          <div className="faq-label margin-md-bottom" key={key}>
            {intl.formatMessage(eventFaqDefinition.event_activities.prohibited_activities[activity])}
          </div>))}
        {hasOtherProhibitedActivity && <div className="faq-label margin-md-bottom">
          {faqData[OTHER_PROHIBITED_ACTIVITY]}
        </div>}
      </div>
    </div>
  );
};

EventActivitiesExpanded.propTypes = {
  faqData: PropTypes.object,
  prohibitedActivities: PropTypes.array,
  hasOtherProhibitedActivity: PropTypes.bool,
  intl: PropTypes.object
};

export default injectIntl(EventActivitiesExpanded);
